// extracted by mini-css-extract-plugin
module.exports = {"overdue":"dueDate_overdue__id14Y","duedate":"dueDate_duedate__1UFWd","inline":"dueDate_inline__PVPHC"};